var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["anno", this.maskShow ? "" : "row"] }, [
    _c("div", {
      directives: [
        {
          name: "wechat-title",
          rawName: "v-wechat-title",
          value: _vm.$route.meta.title,
          expression: "$route.meta.title"
        }
      ]
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "room-tips" }, [
        _c("p", [_vm._v("تعال والعب معنا أمونج آس")]),
        _vm._v(" "),
        _c("img", { staticClass: "userImg", attrs: { src: _vm.headImg } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c("div", { staticClass: "contentView" }, [
          _c("div", { ref: "Myswper", staticClass: "swiper-container" }, [
            _vm._m(0)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "room-home" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mySwiper.realIndex == 0,
                expression: "mySwiper.realIndex==0"
              }
            ],
            staticClass: "bubble-box bubble-box-left"
          },
          [
            _vm.leftNum >= 1 ? _c("p", { staticClass: "up" }) : _vm._e(),
            _vm._v(" "),
            _vm.leftNum >= 2 ? _c("p", { staticClass: "down" }) : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mySwiper.realIndex == 1,
                expression: "mySwiper.realIndex==1"
              }
            ],
            staticClass: "bubble-box bubble-box-right"
          },
          [
            _vm.rightNum >= 1 ? _c("p", { staticClass: "up" }) : _vm._e(),
            _vm._v(" "),
            _vm.rightNum >= 2 ? _c("p", { staticClass: "down" }) : _vm._e()
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.tips != ""
      ? _c("div", { staticClass: "tips", class: { on: _vm.tips != "" } }, [
          _c("p", [_vm._v(_vm._s(_vm.tips))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "bottomView",
        class: ["footerView", _vm.toBottom == true ? "footerView1" : ""]
      },
      [
        _c(
          "button",
          { staticClass: "clickBtn", attrs: { id: "downloadButton" } },
          [_vm._v("تحميل")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "swiper-wrapper" }, [
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "zong_zi_1" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-slide" }, [
        _c("div", { staticClass: "zong_zi_2" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47359196", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_0eb103b55073f995f96d18576d800012/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47359196","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_0eb103b55073f995f96d18576d800012/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AmongUsShare.vue
// module id = null
// module chunks = 